import { render, staticRenderFns } from "./LucidFeeds.vue?vue&type=template&id=5161633c&scoped=true&"
import script from "./LucidFeeds.vue?vue&type=script&lang=js&"
export * from "./LucidFeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161633c",
  null
  
)

export default component.exports